import { api } from '@/lib/api';

export interface CnpjDTO {
  id: string;
  cnpj: string;
  legalName: string;
  tradeName: string | null;
  isDefault: boolean;
  municipalityCode: string;
  stateCode: string;
  inscricaoMunicipal: string | null;
  cnae: string | null;
}

export const cnpjsApi = {
  list: () => api.get<CnpjDTO[]>('/cnpjs'),
};
